import { WorkspaceOrganizationScene } from '@/features/workspaces/WorkspaceOrganizationScene';
import { useLocalSearchParams } from 'expo-router';

export default function WorkspaceOrganizationScreen() {
  const { id } = useLocalSearchParams<{ id?: string }>();
  const organizationID = typeof id === 'string' ? id : '';

  return <WorkspaceOrganizationScene organizationID={organizationID} />;
}
